<template>
    <div>

      <Aisle v-if="seat.id == 'aisle'"></Aisle>
      <Gap  v-else-if="seat.id == 'gap'"></Gap>
      <Seat :seat="seat" v-else-if="seat.id != 'aisle'" :orientation="orientation" @selected="selectSeat" :is-selected="isSelected"/>




    </div>
</template>

<script>
import Seat from './Seat.vue'
import Aisle from './Aisle.vue'
import Gap from './Gap.vue'

export default {
  components: {
    Seat,
    Aisle,
    Gap,
  },
  data(){
    return {
      selectedSeatId: 0,
    }
  },
  methods: {
    selectSeat(value){
      this.selectedSeatId = 0;
      this.selectedSeatId = value.id;
      this.$emit('selected', value)
    }
  },
  props: {
      seat: Object,
      orientation: String
  },
  computed: {
    isSelected(){
      return this.seat.id === this.selectedSeatId ? 'background: #a4393a; color: #fff;' : '';
    }
  }
}

</script>

<style scoped>
</style>
